<template lang="pug">
  .height-100
    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(key="lista_solicitud_por_aprobar")
        .contenedor-interno
          .title
            span Mis contratos
          transition(name="fade")
            div.position-relative(
              key="list-solicitudes"
            )
              .modal.is-active(v-if="mostrarConfirmacionFirmar")
                confirmar-accion-overlay(
                  @close="mostrarConfirmacionFirmar = false"
                  @do="generarToken()"
                  ref="firmarContrato"
                )
                  span(slot="title") ¿Desea firmar su contrato?
                  span(slot="primaryAction")
                    template(v-if="isSending")
                      | cargando...
                    template(v-else)
                      | Firmar
              .modal.is-active(key="modal-posicion-token",v-if="mostrarModalConfirmacionToken", :class="{'modal-sidebar-desktop-open': showSidebarDesktop }")
                .modal-background
                .card
                  header.modal-card-head.display-flex
                    p.flex-1
                      span Le ha llegado el token de validacion a su correo:&nbsp
                      strong {{ correoServer }}
                  .card-content
                    p Dispone de {{ cuentaRegresiva }} para utilizar el token enviado.
                    .contenedor-datos.fdc
                      .control
                        label Token
                          input.input(type="number", v-model="tokenCliente")
                  footer.card-footer
                    a.card-footer-item.is-success(@click="guardarGenerarToken")
                      span Guardar
                    a.card-footer-item(@click="cerrarModalConfirmacionToken")
                      strong Cancelar
              div
                loading(v-if="isLoading")
                table.table.is-striped.is-bordered(v-if="!isLoading && lista.length > 0")
                  thead
                    th Duración
                    th Creación
                    th Acciones
                  tbody(
                    name="table-row"
                    is="transition-group"
                  )
                    tr.row-table(
                      v-for="(o, index) in lista"
                      :key="index"
                    )
                      td
                        .hint--top(:aria-label="'Contrato: ' + o.id")
                          span(v-if="!o.indeterminado") {{ o.fechaInicio }} - {{ o.fechaFin }}
                          span(v-else) Indeterminado
                      td
                        | {{ o.creado }}
                      td.text-center
                        .contenedor-acciones.fdc
                          button.button.is-small(@click="verContrato(o)")
                            span.icon.is-small
                              i.fa.fa-paperclip.is-small.fs-12
                            span Ver adjunto
                          template(v-if="!o.firmado")
                            .hint--top.d-flex(aria-label="Debe visualizar su contrato antes de firmarlo" v-if="!o.primera_visualizacion")
                              button.button.is-small(disabled)
                                span.icon.is-small
                                  i.fa.fa-pencil
                                span Firmar
                            button.button.is-small(v-else @click="confirmacionFirmar(o)")
                              span.icon.is-small
                                i.fa.fa-pencil
                              span Firmar
                          .firmado.fs-12(v-else)
                            span Firmado:&nbsp;
                            span {{ o.fechaFirma }}
                .info-message(v-if="!isLoading && lista.length === 0")
                  span No se encontraron contratos
</template>

<script>
import { apiGet, apiPost, notify } from '../util/general'
import ConfirmarAccionOverlayComponent from '../components/Component_Confirmar_Accion_Overlay'
import moment from 'moment'
export default {
  name: 'lista_solicitud_vacaciones_component',
  components: {
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  data () {
    return {
      lista: [],
      isLoading: false,
      mostrarConfirmacionFirmar: false,
      mostrarModalConfirmacionToken: false,
      correoServer: null,
      tokenCliente: null,
      fechaObjetivo:new Date(),
      cuentaRegresiva:null,
      esVer: false,
      contrato: null,
      isSending: false
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  methods: {
    actualizarCuentaRegresiva () {
      const ahora = moment();
      const duracion = moment.duration(this.fechaObjetivo.diff(ahora));

      // const dias = Math.floor(duracion.asDays());
      // const horas = duracion.hours();
      const minutos = duracion.minutes();
      const segundos = duracion.seconds();

      // Actualiza la cuenta regresiva en formato 'X días, XX:XX:XX'
      this.cuentaRegresiva = `${this.formatearTiempo(minutos)}:${this.formatearTiempo(segundos)}`;

      // Detener la cuenta regresiva si se alcanza la fecha objetivo
      if (duracion.asSeconds() <= 0) {
        this.cuentaRegresiva = '¡El tiempo ha llegado!';
        clearInterval(this.intervalo);
      }
    },
    formatearTiempo (valor) {
      return valor < 10 ? '0' + valor : valor;
    },
    fetch () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/contratos/obtener/mis-contratos', obj, function (data) {
        if (data.status === 1) {
          vm.lista = data.lista
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    verContrato (o) {
      this.contrato = o
      if (o.primera_visualizacion) {
        this.obtenerLinkContrato()
        return
      }
      this.generarTokenVer()
    },
    confirmacionFirmar (o) {
      this.mostrarConfirmacionFirmar = true
      this.contrato = o
    },
    firmar () {
      var vm = this
      if (vm.isSending) return
      vm.isSending = true
      var obj = {
        id: vm.contrato.id,
        tokenContrato: vm.tokenCliente
      }
      apiPost(vm, '/contratos/firmar', obj, function (data) {
        if (data.status === 1) {
          notify(vm, 'success', 'Éxito', data.message)
          vm.fetch()
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSending = false
        vm.mostrarConfirmacionFirmar = false
        vm.mostrarModalConfirmacionToken = false
        apiGet(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
          vm.$store.dispatch('setContratosPorFirmar', data.lista.filter(a => !a.firmado).length)
        })
      })
    },
    generarTokenVer () {
      var vm = this
      var obj = {
        id: vm.contrato.id
      }
      apiPost(vm, '/contratos/firmar/generar-token/ver', obj, function (data) {
        if (data.status === 1) {
          notify(vm, 'success', 'Éxito', data.message)
          vm.correoServer = data.correo
          vm.mostrarConfirmacionFirmar = false
          vm.mostrarModalConfirmacionToken = true
          vm.esVer = true
          vm.fechaObjetivo = moment(data.duracionVerTokenContrato)
          vm.actualizarCuentaRegresiva();
          vm.intervalo = setInterval(vm.actualizarCuentaRegresiva, 1000);
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.mostrarConfirmacionFirmar = false
        vm.tokenCliente = null
      })
    },
    generarToken () {
      var vm = this
      var obj = {
        id: vm.contrato.id
      }
      apiPost(vm, '/contratos/firmar/generar-token', obj, function (data) {
        if (data.status === 1) {
          notify(vm, 'success', 'Éxito', data.message)
          vm.correoServer = data.correo
          vm.mostrarConfirmacionFirmar = false
          vm.mostrarModalConfirmacionToken = true
          vm.fechaObjetivo = moment(data.duracionTokenContrato)
          vm.actualizarCuentaRegresiva();
          vm.intervalo = setInterval(vm.actualizarCuentaRegresiva, 1000);
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.mostrarConfirmacionFirmar = false
        vm.tokenCliente = null
      })
    },
    guardarGenerarToken () {
      var vm = this
      if (vm.esVer) {
        vm.obtenerLinkContrato()
        return
      }
      vm.firmar()
      clearInterval(this.intervalo);
    },
    obtenerLinkContrato () {
      var vm = this
      var obj = { id: vm.contrato.id }
      if (!vm.contrato.primera_visualizacion) {
        obj.tokenContrato = vm.tokenCliente
      }
      apiGet(vm, '/contratos/obtener/path-contrato', obj, function (data) {
        vm.fetch()
        if (data.status === 1) {
          window.open(data.pathContrato, '_blank')
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.mostrarModalConfirmacionToken = false
        vm.contrato = null
        vm.tokenCliente = null
        vm.esVer = false
      })
    },
    cerrarModalConfirmacionToken () {
      this.mostrarModalConfirmacionToken = false
      this.tokenCliente = null
      clearInterval(this.intervalo);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .d-flex
    display flex !important
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      cursor pointer
      i
        font-size 16px

    .title
      padding-left: 10px
      padding-right: 10px
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  .contenedor-acciones
    padding-top 4px
    display flex
    justify-content space-around
    .button
      flex 1
      margin 5px 0px
      // i
      //   margin-left 2px
      //   font-size 15px

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important

  th
    text-align center

  td
    vertical-align: middle;

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .show-closed-text
    cursor pointer
    color #12537e
    padding-bottom 10px


  .dias-pedidos
    font-size 12px
    color #9a9a9a

  .fs-12
    font-size 12px

  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px

  @media (max-width 578px)
    .is-mobile
      display block

    .is-desktop
      display none

    table
      tbody
        font-size 11px

</style>



// WEBPACK FOOTER //
// View_Mis_Contratos.vue?c37a5e36